import EA from '../helpers/init';

export default EA.Methods.openPositionsHandler = ($this) => {
    const section = $this;
    const buttons = section.querySelectorAll('.open-positions-btn');
    const details = section.querySelectorAll('.open-position-detail');
    const wrapper = section.querySelector('.open-positions-outer-wrapper');

    function setWrapperHeight(detail) {
        setTimeout(() => {
            wrapper.style.height = detail.offsetHeight + 'px';
        }, 300);
    }

    const initialActive = section.querySelector('.open-position-detail.active');
    if(initialActive) {
        setWrapperHeight(initialActive);
    }

    buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
            buttons.forEach(btn => btn.classList.remove('active'));
            button.classList.add('active');

            details.forEach(detail => detail.classList.remove('active'));
            details[index]?.classList.add('active');

            if (details[index]) setWrapperHeight(details[index]);
        });
    });

    let timeoutId;

    window.addEventListener('resize', () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            setWrapperHeight(section.querySelector('.open-position-detail.active'));
        }, 50);
    });
};
